export const environment = {
  production: true,
  baseUrl: 'https://gb-develop.worldoffice.cloud/',
  apiUrl: 'https://o2j1iivjr2.execute-api.us-east-2.amazonaws.com/develop',
  eventsUrl: 'https://d32t4o83u0i5de.cloudfront.net/orders/v1/events',
  imagesUrl: 'https://woteststorage.blob.core.windows.net/wofiles/',
  // Mock temporal: ver environment.ts para el detalle de cada flag.
  // Activo tambien en develop porque los backends reales aun no estan
  // disponibles/estables en este ambiente.
  mockProveedoresWoCloud: true,
  mockCatalogoPos: false,
  mockAdicionalesPos: false,
  mockGastosPos: true,
  // Backend real confirmado (2026-09-08) para la precuenta en
  // GET /orders/v1/orders/:orderId/review-account. Ver environment.ts.
  mockCuentaRevisionPos: false,
  // Mock temporal: no existe backend de direcciones/zonas/repartidores todavia.
  mockDireccionClientePos: true,
  // Mock temporal: el backend de validacion de contexto de canal (HU-BE-POS-PED-002) aun no esta desplegado.
  mockContextoPedidoPos: true,
  // Mock temporal: el backend de calculo de pedido (HU-BE-004) aun no esta desplegado.
  mockCalculoPedidoPos: true,
  // Mock temporal: el backend de envio a produccion (HU-BE-006) y el de
  // novedades de pedido (HU-BE-007) aun no estan desplegados. Cubre ambos
  // metodos (enviarAProduccion/registrarNovedad en pedido-mock-api.ts) por
  // ser la misma familia de negocio de "eventos de produccion".
  mockEnvioProduccionPos: true,
  // Mock temporal: el backend de marcar-listo/entrega de pedido (HU-BE-008)
  // aun no esta desplegado. Concepto de negocio distinto a
  // mockEnvioProduccionPos (entrega vs produccion), por eso tiene su propio
  // flag.
  mockEntregaPedidoPos: true,
  // Mock temporal: el backend de cobro de pedido (HU-BE-009) aun no esta desplegado.
  mockCobroPedidoPos: true,
  // Mock temporal: no existe backend de favoritos por usuario ni el reporte de
  // mas vendidos de la sede (Destacados, HU-19950). Solo se usan con el flag
  // ALCANCE_RELEASE_POS_VENTAS.destacados encendido (posFunciones).
  mockFavoritosPos: true,
  mockMasVendidosPos: true,
  // Mock temporal: no existe backend de empaques (bolsas de Para llevar, HU-19918).
  // Ver empaques-mock-api.ts. prod, quality y stage NO definen este campo (lo vigila
  // mock-empaques-pos.spec.ts).
  mockEmpaquesPos: true,
  // Impresión automática por estación (HU-FE-POS-KDS-002): 'mock' usa impresion-automatica-mock-api.ts
  // porque aún no hay backend. prod, quality y stage NO definen este campo, así que la sección
  // queda oculta allá (lo vigila impresion-automatica-env.spec.ts).
  impresionAutomatica: 'mock',
  // Funciones de POS Ventas por ambiente (ver funciones-pos.ts / ALCANCE_RELEASE_POS_VENTAS).
  // Encendidas en develop para ver toda la UI aunque el back no las soporte del todo,
  // con mocks donde aun no hay backend. Los ambientes desplegados (prod, quality, stage)
  // NO definen este campo (lo vigila funciones-pos.spec.ts).
  posFunciones: {
    ventaRapida: true,
    destacados: true,
    empaques: true,
    canales: ['para_llevar'],
  },
  microfrontends: {
    'mf-sales':
      'https://gb-develop.worldoffice.cloud/mf-sales/remoteEntry.json',
    'mf-inventory':
      'https://gb-develop.worldoffice.cloud/mf-inventory/remoteEntry.json',
    'mf-kds': 'https://gb-develop.worldoffice.cloud/mf-kds/remoteEntry.json',
  },
};
